import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import CheckBox from 'src/components/CheckBox';
import TruncateTextCmp from 'src/components/TruncateText';
import { RootState } from 'src/redux/store';

interface ILineItemRowsProps {
    data: any;
    selectedIds?: number[];
    onToggleSelect?: (id: number) => void;
}

const LineItemRows = ({ data, selectedIds, onToggleSelect }: ILineItemRowsProps) => {
    const handlingUnitOptions = useSelector((state: RootState) => state.basic.handlingUnitOptions);
    const descriptionRef = useRef<HTMLHeadingElement>(null);
    const refNumberRef = useRef<HTMLHeadingElement>(null);
    const handlingUnit = handlingUnitOptions?.find((item: any) => item?.value === data?.handlingUnit);
    const weightUnit = data?.weightMeasurement === 'KGS' ? 'kgs' : 'lbs';

    return (
        <>
            <td className="w-[40px] min-w-[40px] max-w-[40px] sticky left-0 bg-inherit z-[1] table-cell-with-tooltip !py-0" onClick={(e) => e.stopPropagation()}>
                <CheckBox
                    id={`selectLineItem-${data?.id}`}
                    checked={selectedIds?.includes(data?.id) ?? false}
                    onChangeFunc={() => onToggleSelect?.(data?.id)}
                    name={`selectLineItem-${data?.id}`}
                    value={String(data?.id)}
                    parentClassName="px-3 h-full items-center"
                />
            </td>
            <td className="min-w-[90px] w-[10.43%] max-w-[130px]">{data?.handlingUnitNo || '-'}</td>
            <td className="w-[12.43%] min-w-[100px]  max-w-[145px]">{handlingUnit?.label || data?.handlingUnit || '-'}</td>
            <td className="w-[12.43%] min-w-[100px]  max-w-[145px]">{data?.length && data?.width && data?.height ? `${data.length} x ${data.width} x ${data.height}` : '-'}</td>
            <td className="w-[12.43%] min-w-[100px]  max-w-[145px]">{data?.freightClass || '-'}</td>
            <td className="w-[13.43%] min-w-[100px]  max-w-[145px]">{data?.weight ? `${data.weight} ${weightUnit}` : '-'}</td>
            <td className="w-[13.43%] min-w-[100px]  max-w-[145px]">{data?.totalWeight ? `${data.totalWeight} ${weightUnit}` : '-'}</td>
            <td className="w-[12.43%] min-w-[100px]  max-w-[145px]">
                <TruncateTextCmp message={data?.refNumber || '-'} refName={refNumberRef}>
                    <h6 className="truncate block" ref={refNumberRef}>
                        {data?.refNumber || '-'}
                    </h6>
                </TruncateTextCmp>
            </td>
            <td className="w-[13.43%] min-w-[100px]  max-w-[145px]">
                <TruncateTextCmp message={data?.commodity || '-'} refName={descriptionRef}>
                    <h6 className="truncate" ref={descriptionRef}>
                        {data?.commodity || '-'}
                    </h6>
                </TruncateTextCmp>
            </td>
        </>
    );
};

export default LineItemRows;
